import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2483fd8c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=2483fd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483fd8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2483fd8c')) {
      api.createRecord('2483fd8c', component.options)
    } else {
      api.reload('2483fd8c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2483fd8c&scoped=true&", function () {
      api.rerender('2483fd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23COGGEW5QNJj/JS/comp/Voucher.vue"
export default component.exports